<template>
  <field-frame :field="field" :show-optional="showOptional">
    <template #default="{ inputId, describedBy, requiredEmpty }">
      <div class="flex items-center gap-1.5">
        <span v-if="field.prefix" class="text-q4cl-muted text-sm">{{ $t(field.prefix) }}</span>
        <input
          :id="inputId"
          type="date"
          class="field-input"
          :autocomplete="field.autocomplete || 'bday'"
          :max="field.max || undefined"
          :min="field.min || undefined"
          :aria-required="field.required ? 'true' : 'false'"
          :aria-invalid="requiredEmpty ? 'true' : 'false'"
          :aria-describedby="describedBy"
          v-model="field.value"
        />
        <span v-if="field.postfix" class="text-q4cl-muted text-sm">{{ $t(field.postfix) }}</span>
      </div>
      <p v-if="wareki" class="text-sm text-q4cl-muted mt-1" v-html="wareki"></p>
    </template>
  </field-frame>
</template>

<script>
import FieldFrame from '@/components/ui/FieldFrame.vue'
export default {
  name: 'DateField',
  components: {
    'field-frame': FieldFrame
  },
  props: {
    field: { type: Object, required: true },
    showOptional: { type: Boolean, default: false }
  },
  setup(props) {
    const wareki = Vue.computed(() => {
      const fmt = props.field.format || 'YYYY/MM/DD';
      return window.mixinUtils.warekiYear(props.field.value, fmt);
    });
    return { wareki };
  }
};
</script>
